import { Component, inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbComponent, IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { UserManagementRolesTeamsTabComponent } from './roles-teams-tab/user-management-roles-teams-tab.component';
import { UserManagementSharedDataStore } from './user-management-shared-data.store';
import { UserManagementUsersTabComponent } from './users-tab/user-management-users-tab.component';

@Component({
  imports: [
    BreadcrumbComponent,
    MatTabsModule,
    TranslateModule,
    UserManagementRolesTeamsTabComponent,
    UserManagementUsersTabComponent,
  ],
  providers: [UserManagementSharedDataStore],
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
})
export class UserManagementComponent {
  private readonly translate = inject(TranslateService);
  private readonly sharedData = inject(UserManagementSharedDataStore);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.settings.accountPanel'),
      link: '/dashboard',
    },
    {
      label: this.translate.instant('pages.settings.userManagement.title'),
    },
  ];

  constructor() {
    // Provided on this component (see `providers` above), not root, so a fresh
    // UserManagementSharedDataStore instance - and a fresh fetch of everything - is created every
    // time this page is opened, rather than a root singleton quietly serving stale data left over
    // from a previous visit. See that store's doc comment for the full reasoning.
    this.sharedData.ensureLoaded();
  }
}
